/**
 * Common icon components shared across features
 */
export const InfoIconOutline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'>
			<path
				d='M7.41667 7.41667L7.44856 7.40111C7.54829 7.35129 7.66021 7.33108 7.77107 7.3429C7.88193 7.35471 7.98709 7.39805 8.07408 7.46778C8.16107 7.5375 8.22626 7.6307 8.26193 7.73632C8.2976 7.84195 8.30225 7.95559 8.27533 8.06378L7.72467 10.2696C7.69756 10.3778 7.70206 10.4915 7.73765 10.5973C7.77324 10.7031 7.83841 10.7964 7.92544 10.8662C8.01247 10.9361 8.11771 10.9795 8.22866 10.9913C8.33962 11.0032 8.45164 10.9829 8.55144 10.933L8.58333 10.9167M15 8C15 8.91925 14.8189 9.82951 14.4672 10.6788C14.1154 11.5281 13.5998 12.2997 12.9497 12.9497C12.2997 13.5998 11.5281 14.1154 10.6788 14.4672C9.82951 14.8189 8.91925 15 8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.82951 1 8.91925 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8ZM8 5.08333H8.00622V5.08956H8V5.08333Z'
				stroke='#666666'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
		</svg>
	);
};

export const EyeIcon = () => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M2 12C2 12 5 5 12 5C19 5 22 12 22 12C22 12 19 19 12 19C5 19 2 12 2 12Z'
			stroke='currentColor'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<circle
			cx='12'
			cy='12'
			r='3'
			stroke='currentColor'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export const EyeOffIcon = () => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M9.88 9.88C9.58 10.18 9.38 10.57 9.31 11C9.24 11.43 9.3 11.87 9.49 12.26C9.68 12.65 10 12.97 10.39 13.16C10.78 13.35 11.22 13.41 11.65 13.34C12.08 13.27 12.47 13.07 12.77 12.77M17.94 17.94C16.23 19.24 14.14 19.97 12 20C5 20 1 12 1 12C2.24 9.68 3.97 7.65 6.06 6.06L17.94 17.94ZM9.9 4.24C10.59 4.08 11.29 4 12 4C19 4 23 12 23 12C22.39 13.14 21.66 14.21 20.83 15.19L9.9 4.24Z'
			stroke='currentColor'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M1 1L23 23'
			stroke='currentColor'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export const CheckIcon = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='160'
		height='160'
		viewBox='0 0 160 160'
		fill='none'>
		<rect x='58' y='22' width='80' height='80' rx='40' fill='#00805E' />
		<foreignObject x='6' y='6' width='148' height='148'>
			<div
				style={{
					backdropFilter: 'blur(15px)',
					clipPath: 'url(#bgblur_0_2064_11233_clip_path)',
					height: '100%',
					width: '100%',
				}}></div>
		</foreignObject>
		<g filter='url(#filter0_di_2064_11233)' data-figma-bg-blur-radius='30'>
			<rect
				x='36'
				y='36'
				width='88'
				height='88'
				rx='16'
				fill='#D9D9D9'
				fill-opacity='0.3'
				shape-rendering='crispEdges'
			/>
			<rect
				x='36.5'
				y='36.5'
				width='87'
				height='87'
				rx='15.5'
				stroke='#CECECE'
				stroke-opacity='0.2'
				shape-rendering='crispEdges'
			/>
		</g>
		<path
			fill-rule='evenodd'
			clip-rule='evenodd'
			d='M95.3386 70.3234C95.6029 69.9688 95.7942 69.5645 95.9011 69.1345C96.008 68.7044 96.0285 68.2571 95.9613 67.8189C95.8941 67.3807 95.7406 66.9605 95.5098 66.5829C95.279 66.2054 94.9756 65.878 94.6173 65.6202C94.2591 65.3624 93.8533 65.1793 93.4238 65.0817C92.9943 64.984 92.5497 64.9738 92.1162 65.0517C91.6828 65.1295 91.2691 65.2938 90.8996 65.5349C90.5301 65.776 90.2121 66.0891 89.9645 66.4557L75.7098 86.5483L68.556 79.3451C67.9297 78.7575 67.1014 78.4376 66.2455 78.4528C65.3896 78.468 64.573 78.8172 63.9677 79.4267C63.3623 80.0361 63.0156 80.8584 63.0005 81.7202C62.9854 82.5821 63.3031 83.4161 63.8867 84.0467L73.798 94.0265C74.1372 94.3678 74.546 94.6306 74.9961 94.7967C75.4463 94.9629 75.9269 95.0284 76.4048 94.9887C76.8826 94.9491 77.3461 94.8052 77.7631 94.567C78.1802 94.3289 78.5407 94.0022 78.8198 93.6096L95.3386 70.3234Z'
			fill='white'
		/>
		<defs>
			<filter
				id='filter0_di_2064_11233'
				x='6'
				y='6'
				width='148'
				height='148'
				filterUnits='userSpaceOnUse'
				color-interpolation-filters='sRGB'>
				<feFlood flood-opacity='0' result='BackgroundImageFix' />
				<feColorMatrix
					in='SourceAlpha'
					type='matrix'
					values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
					result='hardAlpha'
				/>
				<feOffset />
				<feGaussianBlur stdDeviation='10' />
				<feComposite in2='hardAlpha' operator='out' />
				<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
				<feBlend
					mode='normal'
					in2='BackgroundImageFix'
					result='effect1_dropShadow_2064_11233'
				/>
				<feBlend
					mode='normal'
					in='SourceGraphic'
					in2='effect1_dropShadow_2064_11233'
					result='shape'
				/>
				<feColorMatrix
					in='SourceAlpha'
					type='matrix'
					values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
					result='hardAlpha'
				/>
				<feOffset dx='2' dy='2' />
				<feGaussianBlur stdDeviation='5' />
				<feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
				<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
				<feBlend mode='normal' in2='shape' result='effect2_innerShadow_2064_11233' />
			</filter>
			<clipPath id='bgblur_0_2064_11233_clip_path' transform='translate(-6 -6)'>
				<rect x='36' y='36' width='88' height='88' rx='16' />
			</clipPath>
		</defs>
	</svg>
);

export const XIcon = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='160'
		height='160'
		viewBox='0 0 160 160'
		fill='none'>
		<rect x='58' y='22' width='80' height='80' rx='40' fill='black' />
		<foreignObject x='6' y='6' width='148' height='148'>
			<div
				style={{
					backdropFilter: 'blur(15px)',
					clipPath: 'url(#bgblur_0_2064_11241_clip_path)',
					height: '100%',
					width: '100%',
				}}></div>
		</foreignObject>
		<g filter='url(#filter0_di_2064_11241)' data-figma-bg-blur-radius='30'>
			<rect
				x='124'
				y='36'
				width='88'
				height='88'
				rx='16'
				transform='rotate(90 124 36)'
				fill='#D9D9D9'
				fill-opacity='0.3'
				shape-rendering='crispEdges'
			/>
			<rect
				x='123.5'
				y='36.5'
				width='87'
				height='87'
				rx='15.5'
				transform='rotate(90 123.5 36.5)'
				stroke='#CECECE'
				stroke-opacity='0.2'
				shape-rendering='crispEdges'
			/>
		</g>
		<path
			d='M70.4108 65.4899C70.8679 65.6936 71.2793 65.9872 71.6205 66.3534L80.1672 74.9001L88.7139 66.3534C89.0551 65.9872 89.4665 65.6936 89.9237 65.4899C90.3808 65.2862 90.8743 65.1766 91.3747 65.1678C91.8751 65.159 92.3722 65.251 92.8362 65.4385C93.3003 65.6259 93.7218 65.9049 94.0757 66.2588C94.4296 66.6127 94.7086 67.0342 94.896 67.4983C95.0834 67.9623 95.1755 68.4593 95.1667 68.9597C95.1578 69.4601 95.0483 69.9536 94.8446 70.4108C94.6409 70.8679 94.3472 71.2793 93.9811 71.6205L85.4344 80.1672L93.9811 88.7139C94.3472 89.0551 94.6409 89.4665 94.8446 89.9237C95.0483 90.3808 95.1578 90.8743 95.1667 91.3747C95.1755 91.8751 95.0834 92.3722 94.896 92.8362C94.7086 93.3003 94.4296 93.7218 94.0757 94.0757C93.7218 94.4296 93.3003 94.7086 92.8362 94.896C92.3722 95.0834 91.8751 95.1755 91.3747 95.1667C90.8743 95.1578 90.3808 95.0483 89.9237 94.8446C89.4665 94.6409 89.0551 94.3472 88.7139 93.9811L80.1672 85.4344L71.6205 93.9811C71.2793 94.3472 70.8679 94.6409 70.4108 94.8446C69.9536 95.0483 69.4601 95.1578 68.9597 95.1667C68.4593 95.1755 67.9623 95.0834 67.4983 94.896C67.0342 94.7086 66.6127 94.4296 66.2588 94.0757C65.9049 93.7218 65.6259 93.3003 65.4385 92.8362C65.251 92.3722 65.159 91.8751 65.1678 91.3747C65.1766 90.8743 65.2862 90.3808 65.4899 89.9237C65.6935 89.4665 65.9872 89.0551 66.3534 88.7139L74.9001 80.1672L66.3534 71.6205C65.9872 71.2793 65.6935 70.8679 65.4899 70.4108C65.2862 69.9536 65.1766 69.4601 65.1678 68.9597C65.159 68.4593 65.251 67.9623 65.4385 67.4983C65.6259 67.0342 65.9049 66.6127 66.2588 66.2588C66.6127 65.9049 67.0342 65.6259 67.4983 65.4385C67.9623 65.251 68.4593 65.159 68.9597 65.1678C69.4601 65.1766 69.9536 65.2862 70.4108 65.4899Z'
			fill='white'
		/>
		<defs>
			<filter
				id='filter0_di_2064_11241'
				x='6'
				y='6'
				width='148'
				height='148'
				filterUnits='userSpaceOnUse'
				color-interpolation-filters='sRGB'>
				<feFlood flood-opacity='0' result='BackgroundImageFix' />
				<feColorMatrix
					in='SourceAlpha'
					type='matrix'
					values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
					result='hardAlpha'
				/>
				<feOffset />
				<feGaussianBlur stdDeviation='10' />
				<feComposite in2='hardAlpha' operator='out' />
				<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
				<feBlend
					mode='normal'
					in2='BackgroundImageFix'
					result='effect1_dropShadow_2064_11241'
				/>
				<feBlend
					mode='normal'
					in='SourceGraphic'
					in2='effect1_dropShadow_2064_11241'
					result='shape'
				/>
				<feColorMatrix
					in='SourceAlpha'
					type='matrix'
					values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
					result='hardAlpha'
				/>
				<feOffset dx='2' dy='2' />
				<feGaussianBlur stdDeviation='5' />
				<feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
				<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
				<feBlend mode='normal' in2='shape' result='effect2_innerShadow_2064_11241' />
			</filter>
			<clipPath id='bgblur_0_2064_11241_clip_path' transform='translate(-6 -6)'>
				<rect x='124' y='36' width='88' height='88' rx='16' transform='rotate(90 124 36)' />
			</clipPath>
		</defs>
	</svg>
);